// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { clearfixStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { Children, FC } from "react";
import { css } from "styled-components";

interface Styles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
    item?: InjectableCss;
}

const styles: Styles = {
    container: {
        css: css`
            width: 100%;
            ${spacingStyles()}
            ${clearfixStyles()}
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-flow: row wrap;
            margin: -10px 0 0 -10px;
        `,
    },
    item: {
        css: css`
            margin: 10px 0 0 10px;
            width: 100%;

            a,
            button {
                width: 100%;
            }

            ${breakpoint("sm")} {
                width: auto;
            }
        `,
    },
};

const StyleguideItems: FC = ({ children }) => {
    if (!children) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.wrapper}>
                {Children.map(children, element =>
                    element ? <StyledWrapper {...styles.item}>{element}</StyledWrapper> : null,
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default StyleguideItems;
